import {
    ShieldCheck,
    AlertTriangle,
    XCircle,
    HelpCircle,
    MailX,
    UserMinus,
} from "lucide-react";

export const EMAIL_STATUS = {
    safe: {
        label: "Safe",
        icon: ShieldCheck,
        badge:
            "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400",
        text: "text-emerald-500",
        pill:
            "bg-emerald-500/10 text-emerald-500 border border-emerald-500/20",
        card: {
            color: "text-emerald-600 dark:text-emerald-400",
            bg: "bg-emerald-50 dark:bg-emerald-500/10",
            border: "border-emerald-100 dark:border-emerald-500/20",
            hover: "hover:border-emerald-300 dark:hover:border-emerald-500/40",
        },

        statCard: {
            base:
                "text-emerald-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-emerald-500/20 hover:dark:bg-[#11271C] hover:bg-[#F0FDF4] hover:dark:border-[#03B383] hover:border-[#6EE7B7]",
            active: "bg-[#03B383] border-[#037D5C]",
        },
    },

    risky: {
        label: "Risky",
        icon: AlertTriangle,

        badge:
            "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",

        text: "text-amber-500",
        pill:
            "bg-amber-500/10 text-amber-500 border border-amber-500/20",
        card: {
            color: "text-amber-600 dark:text-amber-400",
            bg: "bg-amber-50 dark:bg-amber-500/10",
            border: "border-amber-100 dark:border-amber-500/20",
            hover: "hover:border-amber-300 dark:hover:border-amber-500/40",
        },

        statCard: {
            base:
                "text-amber-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-amber-500/20 hover:dark:bg-[#272211] hover:bg-[#FEFCE8] hover:dark:border-[#D4A000] hover:border-[#E8C468]",
            active: "bg-[#EAB308] border-[#BA9A49]",
        },
    },

    invalid: {
        label: "Invalid",
        icon: XCircle,

        badge:
            "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400",

        text: "text-red-500",
        pill:
            "bg-red-500/10 text-red-500 border border-red-500/20",
        card: {
            color: "text-red-700 dark:text-red-400",
            bg: "bg-red-100 dark:bg-red-500/10",
            border: "border-red-200 dark:border-red-500/20",
            hover: "hover:border-red-400 dark:hover:border-red-500/40",
        },

        statCard: {
            base:
                "text-red-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-red-500/20 hover:dark:bg-[#271111] hover:bg-[#FEF2F2] hover:dark:border-[#C94747] hover:border-[#F87171]",
            active: "bg-[#B91C1C] border-[#991B1B]",
        },
    },

    unverified: {
        label: "Unverified",
        icon: HelpCircle,

        badge:
            "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
        text: "text-slate-500",
        pill:
            "bg-blue-500/10 text-blue-500 border border-blue-500/20",
        card: {
            color: "text-slate-600 dark:text-slate-400",
            bg: "bg-slate-50 dark:bg-slate-500/10",
            border: "border-slate-100 dark:border-slate-500/20",
            hover: "hover:border-slate-300 dark:hover:border-slate-500/40",
        },

        statCard: {
            base:
                "text-slate-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-slate-500/20 hover:bg-slate-100 dark:hover:bg-slate-800",
            active: "bg-slate-500 border-slate-600",
        },
    },

    bounced: {
        label: "Bounced",
        icon: MailX,
        pill:
            "bg-rose-500/10 text-rose-500 border border-rose-500/20",
        badge:
            "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",

        text: "text-rose-500",

        card: {
            color: "text-rose-600 dark:text-rose-400",
            bg: "bg-rose-50 dark:bg-rose-500/10",
            border: "border-rose-100 dark:border-rose-500/20",
            hover: "hover:border-rose-300 dark:hover:border-rose-500/40",
        },

        statCard: {
            base:
                "text-rose-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-rose-500/20 hover:bg-rose-50 dark:hover:bg-rose-900/10",
            active: "bg-rose-500 border-rose-600",
        },
    },

    unsubscribed: {
        label: "Unsubscribed",
        icon: UserMinus,

        badge:
            "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",

        text: "text-orange-500",
        pill:
            "bg-orange-500/10 text-orange-500 border border-orange-500/20",
        card: {
            color: "text-orange-600 dark:text-orange-400",
            bg: "bg-orange-50 dark:bg-orange-500/10",
            border: "border-orange-100 dark:border-orange-500/20",
            hover: "hover:border-orange-300 dark:hover:border-orange-500/40",
        },

        statCard: {
            base:
                "text-orange-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-orange-500/20 hover:dark:bg-[#271811] hover:bg-[#F4A4621A]/10 hover:border-[#E76E50]",
            active: "bg-[#F4A462] border-[#E76E50]",
        },
    },

    verification_failed: {
        label: "Verification Failed",
        icon: AlertTriangle,

        badge:
            "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400",

        text: "text-yellow-500",
        pill:
            "bg-yellow-500/10 text-yellow-500 border border-yellow-500/20",
        card: {
            color: "text-yellow-600 dark:text-yellow-400",
            bg: "bg-yellow-50 dark:bg-yellow-500/10",
            border: "border-yellow-100 dark:border-yellow-500/20",
            hover: "hover:border-yellow-300 dark:hover:border-yellow-500/40",
        },

        statCard: {
            base:
                "text-yellow-500 bg-transparent border-gray-200 dark:border-[#1F2937]",
            hover:
                "hover:shadow-yellow-500/20 hover:dark:bg-[#272211] hover:bg-[#FEFCE8] hover:dark:border-[#D4A000] hover:border-[#E8C468]",
            active: "bg-[#EAB308] border-[#BA9A49]",
        },
    },
} as const;